"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var React = __importStar(require("react"));
var styles = __importStar(require("./styles.modules.css"));
var text_1 = require("../text");
var icon_1 = require("../icon");
var button_1 = require("../button");
var container_1 = require("../container");
var logo_1 = require("../logo");
var defaultProps = {
    socials: [
        { link: "https://www.facebook.com/ribitdotnet/", icon: icon_1.Icons.Facebook },
        { link: "https://twitter.com/ribitdotnet", icon: icon_1.Icons.Twitter },
        { link: "https://au.linkedin.com/company/ribit.net", icon: icon_1.Icons.LinkedIn },
        { link: "https://www.instagram.com/ribitdotnet/", icon: icon_1.Icons.Instagram },
        {
            link: "https://www.youtube.com/channel/UC2StYiqddNIgTk8b-vbPptg",
            icon: icon_1.Icons.YouTube,
        },
    ],
    sections: [
        {},
        {
            title: "Platform",
            links: [
                { name: "Students", href: "https://www.ribit.net/student-advice/" },
                {
                    name: "Employers",
                    href: "https://www.ribit.net/category/blog/business-advice/",
                },
                {
                    name: "Case Studies",
                    href: "https://www.ribit.net/category/blog/success-stories/",
                },
            ],
        },
        {
            title: "Events",
            links: [
                {
                    name: "Our events",
                    href: "https://www.eventbrite.com.au/o/csiro-data-61-ribitnet-16792121758",
                },
            ],
        },
        {
            title: "Company",
            links: [
                { name: "About", href: "https://www.ribit.net/about-us/" },
                { name: "Blog", href: "https://www.ribit.net/category/blog/" },
                { name: "Media", href: "https://www.ribit.net/media/" },
                { name: "Contact", href: "https://www.ribit.net/contact/" },
            ],
        },
    ],
    terms: "https://www.ribit.net/terms-conditions/",
    privacy: "https://www.ribit.net/privacy-policy/",
    disclaimer: null,
};
var Footer = function (props) {
    var currentYear = new Date().getFullYear();
    var socials = props.socials, terms = props.terms, privacy = props.privacy, sections = props.sections;
    return (React.createElement("footer", { className: styles.background },
        React.createElement(container_1.Container, null,
            React.createElement("div", { className: styles.footerLinks },
                React.createElement("div", { className: styles.info },
                    React.createElement(logo_1.Logo, { brand: "ribit", className: styles.ribitLogo }),
                    React.createElement(text_1.Text, { className: styles.grow }, "Connecting smart students with technical, engineering, analytical, business, marketing and research skills to innovative businesses."),
                    React.createElement("div", { className: styles.social }, socials.map(function (social) { return (React.createElement(button_1.Button, { key: social.icon, className: styles.link, type: "text", action: social.link, label: React.createElement(icon_1.Icon, { icon: social.icon }) })); }))),
                sections.map(function (section, index) { return (React.createElement("div", { key: index, className: styles.linksSection },
                    !!section.title && (React.createElement(text_1.Heading, { size: text_1.Size.Smallest, text: section.title, className: styles.title })),
                    !!section.links &&
                        section.links.map(function (link) { return (React.createElement(button_1.Button, { key: link.href, className: styles.link, type: "text", action: link.href, label: link.name })); }))); })),
            React.createElement("hr", { className: styles.separator }),
            React.createElement("div", { className: styles.secondary },
                React.createElement(logo_1.Logo, { brand: "readygrad", className: styles.ownerLogo }),
                React.createElement("div", { className: styles.terms },
                    React.createElement(button_1.Button, { type: "text", action: terms, label: "Terms and Conditions", className: styles.link }),
                    React.createElement(button_1.Button, { type: "text", action: privacy, label: "Privacy Policy", className: styles.link })),
                React.createElement(text_1.Text, null,
                    "Copyright \u00A9 ",
                    currentYear,
                    " ReadyGrad")),
            props.disclaimer && (React.createElement("div", { className: styles.disclaimer },
                React.createElement(text_1.Text, null, props.disclaimer))))));
};
exports.Footer = Footer;
Footer.defaultProps = defaultProps;
exports.default = Footer;
//# sourceMappingURL=footer.js.map